export const SHORT_SENTENCES_MODES: Record<ShortSentencesMode, string> = {
  "funny-literature-non-questions": "Funny Literature Non Questions",
  "funny-literature-questions": "Funny Literature Questions",
  "jokes-non-questions": "Jokes Non Questions",
  "jokes-questions": "Jokes Questions",
  "literature-non-questions": "Literature Non Questions",
  "literature-questions": "Literature Questions",
  "short-jokes-non-questions": "Short Jokes Non Questions",
  "short-jokes-questions": "Short Jokes Questions",
  "short-non-questions": "Short Non Questions",
  "short-questions": "Short Questions",
}

export const SHORT_SENTENCES = "SHORT_SENTENCES"
